import React from "react";

const Lock = props => (
  <svg
    height={props.height || "10px"}
    viewBox={props.viewBox || "0 0 8 10"}
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <path id="lock_a" d="M0 0h8v10H0z" />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <mask id="lock_b" fill="#fff">
        <use href="#lock_a" />
      </mask>
      <path
        d="M2.27322404 3.4375h3.45355192v-.75892857c0-.98214286-.7431694-1.78571429-1.70491804-1.78571429-1.00546448 0-1.74863388.80357143-1.74863388 1.78571429V3.4375zm1.74863388 2.27678571c.39344263 0 .69945356.3125.69945356.71428572 0 .22321428-.0874317.40178571-.26229509.53571428v.66964286c0 .625-.91803278.625-.91803278 0v-.66964286c-.13114754-.13392857-.26229509-.3125-.26229509-.53571428 0-.40178572.30601093-.71428572.7431694-.71428572zM6.6010929 3.4375h.56830601C7.65027322 3.4375 8 3.79464286 8 4.28571429v4.86607142C8 9.59821429 7.65027322 10 7.16939891 10H.83060109C.34972678 10 0 9.59821429 0 9.15178571V4.28571429C0 3.79464286.34972678 3.4375.8306011 3.4375h.568306v-.75892857C1.3989071 1.20535714 2.53551913 0 4.02185792 0 5.46448087 0 6.6010929 1.20535714 6.6010929 2.67857143V3.4375z"
        fill="#C8C8C8"
        mask="url(#lock_b)"
      />
    </g>
  </svg>
);

export default Lock;



// WEBPACK FOOTER //
// ./src/components/SVG/Lock.js